// Vendors
import React from 'react';

// Components
import { Trans } from '../../../components/common';
import ServiceIconText from '../../../components/common/ServiceIconText/ServiceIconText';
import SummaryCard from '../../../components/common/Cards/SummaryCard/SummaryCard';

// Helpers
import { capitalize } from '../../../lib/helpers';

// PRJ1417943_IntergrationAccelerator - Separated from UnlinkServiceModal for reusability and agency-specific Props: account, agency, ... (add more as needed)
const DMVSummaryCard = ({ account }) => (
  <SummaryCard
    key={account.vin}
    className="card-flat"
    outlined={false}
  >
    <div className="flex-item">
      <div className="flex-row-wrap">
        <div className="flex-item license-plate-icon">
          <ServiceIconText
            className="agency-linked-services-item-icon-text flex-item"
            type={`license-plate`}
            text={account.plateNumber}
            isUnlinkVehicleModal={true}
          />
        </div>
        <div className="flex-item vehicle-details">
          <SummaryCard.List
            items={[
              {
                label: (
                  <Trans
                    file="Labels"
                    id="vehicleMake"
                    fallback="vehicleMake"
                  />
                ),
                value: capitalize(account.vehicleMake),
              },
              {
                label: (
                  <Trans
                    file="Labels"
                    id="modelYear"
                    fallback="modelYear"
                  />
                ),
                value: account.vehicleModelYear,
              },
              {
                label: (
                  <Trans
                    file="Labels"
                    id="vin"
                    fallback="vin"
                  />
                ),
                value: account.vin,
              },
              {
                label: (
                  <Trans
                    file="Labels"
                    id="registrationExpiry"
                    fallback="registrationExpiry"
                  />
                ),
                value:
                  account.registrationExpiryMonth +
                  '/' +
                  account.registrationExpiryYear,
              },
            ]}
          />
        </div>
      </div>
    </div>
  </SummaryCard>
);

export default DMVSummaryCard;
